export default __webpack_public_path__ + "static/media/sr_tol.377bd9fb.jpg";